module.exports = __webpack_public_path__ + "img/busJah.bae53e38.jpg";